import { useShallow } from 'zustand/react/shallow'
import { useEphemeralStore } from '../../state/useEphemeralStore'

export const useOpenDisclosures = () => {
    const { openDisclosures, closedDiscolures } = useEphemeralStore(
        useShallow((s) => {
            return {
                openDisclosures:
                    s.pageStates[window.location.pathname]?.openDisclosures,
                closedDiscolures:
                    s.pageStates[window.location.pathname]?.closedDisclosures,
            }
        })
    )
    return { openDisclosures, closedDiscolures }
}
